import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Stack,
  // Tag,
  Typography,
} from '@monorepo/nova-ui';

export const HeaderLeftSection: FC = () => {
  const { t } = useTranslation('activityLog');

  return (
    <Stack
      direction={{
        xs: 'column',
        lg: 'row',
      }}
      alignItems="center"
      gap={3}
    >
      <Typography
        variant="body1"
        sx={(theme) => ({
          color: theme.palette.text.primary,
          fontWeight: theme.typography.fontWeightMedium,
        })}
      >
        {t('trades')}
      </Typography>
      {/* <Tag
        label="Jan 10 2005"
        onDelete={() => console.log('delete')}
        sx={(theme) => ({
          backgroundColor: 'transparent',
          border: `1px solid ${theme.palette.text.second}`,
          borderRadius: theme.customShape.borderRadiusFull,
          padding: theme.spacing(1),
          '& .MuiChip-label': {
            color: theme.palette.text.second,
            fontWeight: theme.typography.fontWeightRegular,
          },
        })}
      /> */}
    </Stack>
  );
};
